import { render, staticRenderFns } from "./TagGroupManager.vue?vue&type=template&id=30e9c212&scoped=true"
import script from "./TagGroupManager.vue?vue&type=script&lang=js"
export * from "./TagGroupManager.vue?vue&type=script&lang=js"
import style0 from "./TagGroupManager.vue?vue&type=style&index=0&id=30e9c212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e9c212",
  null
  
)

export default component.exports